<div
  class="offer-card"
  [attr.tabindex]="pageType === 'archive' ? null : 0"
  [attr.aria-label]="cardData?.bankProduct?.bankDetails?.bankName"
  [attr.data-productid]="
    cardData?.bankProduct?.product?.productDetails?.productId
  "
  (click)="
    $event.target.closest('.content__incentives') ||
    $event.target.closest('.popup') ||
    offersType === 'noOffersOfApplication' ||
    pageType === 'archive'
      ? null
      : openOfferDetailsMobile(cardData.id)
  "
  [ngClass]="{
    slider: inSlider,
    preliminary: cardData.contractStateFlow === 'PRELIMINARY',
    noOffers:
      offersType === 'noOffersOfApplication' &&
      cardData.state !== 'IN_PROGRESS',
  }"
>
  <app-bank-promotion
    *ngIf="
      offersType !== 'noOffersOfApplication' &&
      cardData.bankProduct.product.productDetails.bankPromotion &&
      cardData.bankProduct.product.productDetails.bankPromotion.active
    "
    [promotionData]="cardData.bankProduct.product.productDetails.bankPromotion"
    [cardId]="cardData.id"
  >
  </app-bank-promotion>
  <div
    class="offer-card__header"
    *ngIf="offersType !== 'noOffersOfApplication'"
  >
    <div class="header__title-wrap">
      <div class="header__title" *ngIf="cardData.offerResponse?.terms?.comment">
        {{ cardData.offerResponse.terms.comment }}
      </div>
      <div
        class="header__title-attention"
        *ngIf="
          showDurationOffer && pageType !== 'archive' && pageType !== 'active'
        "
      >
        <span *ngIf="leftDays > 0"
          >Angebot nur noch {{ leftDays }} Tage gültig!</span
        >
        <span *ngIf="leftDays <= 0">Angebot nur noch heute gültig!</span>
      </div>
      <div class="header__title-archived" *ngIf="pageType === 'archive'">
        <span>Abgelaufen</span>
      </div>
    </div>
  </div>
  <div class="offer-card__content">
    <div class="content__offer">
      <div class="offer__bank">
        <div class="bank__img" [ngClass]="{ defaultBank: showDefaultBank }">
          <figure>
            <picture title="{{ cardData?.bankProduct?.bankDetails?.bankName }}">
              <source
                media="(-webkit-min-device-pixel-ratio: 1.5) and (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3)"
                srcset="{{logoMobileHighres}}"
              />
              <img
                src="{{ logoMobile }}"
                alt="{{ cardData?.bankProduct?.bankDetails?.bankName }}"
              />
            </picture>
            <figcaption *ngIf="showDefaultBank">
              {{ cardData?.bankProduct?.bankDetails?.bankName }}
            </figcaption>
          </figure>
        </div>
        <div class="bank__stars" *ngIf="false">
          <div class="stars__amount">
            &#9733; &#9733; &#9733; &#9733; &#9734;
          </div>
          <div class="stars__rate">
            <p>(<span>1.054</span>)</p>
          </div>
        </div>
      </div>
      <div class="loan__interestRate">
        <p
          class="loan__interestRate-text"
          *ngIf="cardData.offerResponse?.terms?.interestType === 'VARIABLE'"
        >
          variabler Zins
        </p>
        <p
          class="loan__interestRate-text"
          [class.fixed]="
            cardData.offerResponse?.terms?.interestType !== 'VARIABLE'
          "
          *ngIf="cardData.offerResponse?.terms?.interestType !== 'VARIABLE'"
        >
          Fixzins
        </p>
      </div>
      <div
        class="instant-loan-badge"
        *ngIf="cardData.offerResponse?.terms?.instantLoan"
        title="Sofortkredit"
      >
        <svg-icon
          src="/resultpage/assets/icons/stopwatch-fast.svg"
          [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"
          aria-label="Sofortkredit"
        ></svg-icon>
        <span class="instant-loan-badge__tooltip">Sofortkredit</span>
      </div>
    </div>
    <div
      class="content__details-mobile_badge"
      *ngIf="offersType !== 'noOffersOfApplication'"
    >
      <div class="loan__interestRate">
        <p
          class="loan__interestRate-text"
          *ngIf="cardData.offerResponse?.terms?.interestType === 'VARIABLE'"
        >
          variabler Zins
        </p>
        <p
          class="loan__interestRate-text"
          [class.fixed]="
            cardData.offerResponse?.terms?.interestType !== 'VARIABLE'
          "
          *ngIf="cardData.offerResponse?.terms?.interestType !== 'VARIABLE'"
        >
          Fixzins
        </p>
      </div>
      <div
        class="instant-loan-badge instant-loan-badge--mobile"
        *ngIf="cardData.offerResponse?.terms?.instantLoan"
        title="Sofortkredit"
      >
        <svg-icon
          src="/resultpage/assets/icons/stopwatch-fast.svg"
          [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"
          aria-label="Sofortkredit"
        ></svg-icon>
      </div>
      <div class="rate__coupon-panel" *ngIf="+windowCouponAmount > 0">
        <app-coupon
          [windowCouponLabel]="windowCouponLabel"
          [windowCouponAmount]="windowCouponAmount"
          [popup]="popup"
          [sliderWrapper]="sliderWrapper"
          [cardId]="cardData.id"
          (couponPopupChange)="popupToggle($event, cardData.id, 'coupon')"
        ></app-coupon>
      </div>
    </div>
    <div class="content__details-amount">
      <div
        class="details-amount__offer"
        tabindex="0"
        [attr.aria-labelledby]="getLoanAriaLabelledBy()"
      >
        <div class="loan__subtext" [attr.id]="'loanSubtext-' + cardData.id">
          <span
            >{{
              offersType !== "noOffersOfApplication"
                ? cardData.offerResponse?.terms?.loanAmount?.toLocaleString(
                    "de-DE",
                    { minimumFractionDigits: 0 }
                  )
                : cardData?.loan?.amount?.toLocaleString("de-DE", {
                    minimumFractionDigits: 0,
                  })
            }}
            €</span
          >
          <svg-icon
            src="/resultpage/assets/icons/Kreditsumme.svg"
            class="loan__subtext__icon"
            [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
            aria-hidden="true"
          ></svg-icon>
        </div>
        <p
          class="loan__subtext__title"
          [attr.id]="'loanSubtextTitle-' + cardData.id"
        >
          Kreditsumme
        </p>
        <ng-container *ngIf="twoApplicants">
          <p
            class="loan__title"
            [attr.id]="'loanTitle-' + cardData.id"
            *ngIf="
              cardData?.bankProduct?.product?.productApplicants
                ?.twoApplicantsPossible;
              else oneApplicant
            "
          >
            2 Kreditnehmer
          </p>
          <ng-template #oneApplicant>
            <p class="loan__title" [attr.id]="'loanTitle-' + cardData.id">
              1 Kreditnehmer
            </p>
          </ng-template>
        </ng-container>
      </div>
      <div class="details-amount__month">
        <div
          class="month__amount-wrap"
          tabindex="0"
          [attr.aria-labelledby]="
            'monthAmount-' + cardData.id + ' monthText-' + cardData.id
          "
        >
          <p class="month__amount-wrap-title">Laufzeit</p>
          <div class="month__amount-wrap-icon">
            <div class="month__amount-wrap-inner">
              <span
                class="month__amount"
                [attr.id]="'monthAmount-' + cardData.id"
                >{{
                  offersType !== "noOffersOfApplication"
                    ? cardData.offerResponse.terms?.numberOfInstallments
                    : cardData?.loan?.duration?.slice(1).slice(0, -1)
                }}</span
              >
              <span class="month__text-row">
                <span
                  class="month__text"
                  [attr.id]="'monthText-' + cardData.id"
                >
                  {{
                    offersType !== "noOffersOfApplication"
                      ? cardData.offerResponse.terms?.numberOfInstallments === 1
                        ? "Monat"
                        : "Monate"
                      : +cardData?.loan?.duration?.slice(1).slice(0, -1) === 1
                        ? "Monat"
                        : "Monate"
                  }}
                </span>
                <app-hint
                  *ngIf="durationModification"
                  class="month__duration-hint"
                  [displayCss]="'inline'"
                  [iconSrc]="'/resultpage/assets/icons/INFO.svg'"
                  [hintData]="durationModificationHintData"
                ></app-hint>
              </span>
            </div>
            <svg-icon
              src="/resultpage/assets/icons/Time.svg"
              class="month__amount-wrap-icon__icon"
              [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
              aria-hidden="true"
            ></svg-icon>
          </div>
        </div>
      </div>
      <div class="details-amount__percent">
        <div
          class="percent__amount-wrap"
          *ngIf="offersType !== 'noOffersOfApplication'"
          tabindex="0"
          [attr.aria-labelledby]="
            'interestAmount-' + cardData.id + ' interestText-' + cardData.id
          "
        >
          <div class="percent__amount-wrap-inner">
            <svg
              *ngIf="!cardData.offerResponse.terms?.effectiveInterest"
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 39.81 30"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: #606060;
                    font-family: MyriadPro-Regular, "Myriad Pro";
                    font-size: 12px;
                  }

                  .cls-2 {
                    fill: #666;
                  }
                </style>
              </defs>
              <path
                class="cls-2"
                d="M20.46,18.27l-4.12-3V6.65c0-.51-.41-.92-.92-.92h-.84c-.51,0-.92,.41-.92,.92v9.52c0,.29,.14,.57,.38,.74l4.85,3.52h0c.41,.3,.98,.21,1.29-.2l.49-.67c.14-.2,.2-.44,.17-.68-.04-.24-.17-.46-.37-.6Z"
                vector-effect="non-scaling-stroke"
              />
              <path
                class="cls-2"
                d="M22.35,26.11c0-.31,.06-.62,.18-.91-2.18,1.61-4.82,2.48-7.53,2.48-7,0-12.69-5.69-12.69-12.68S8,2.32,15,2.32s12.69,5.69,12.69,12.68c0,.7-.06,1.4-.17,2.09,.75-.49,1.58-.85,2.45-1.07,.02-.34,.04-.68,.04-1.02,0-6.07-3.66-11.54-9.26-13.86C15.13-1.18,8.68,.1,4.39,4.39-1,9.79-1.49,18.37,3.26,24.33c4.75,5.97,13.22,7.43,19.69,3.39-.39-.45-.6-1.02-.6-1.61Z"
                vector-effect="non-scaling-stroke"
              />
              <text class="cls-1" transform="translate(20.84 24.92)">
                <tspan x="0" y="0">24h</tspan>
              </text>
            </svg>
            <span
              *ngIf="cardData.offerResponse.terms?.effectiveInterest"
              class="percent__amount"
              [attr.id]="'interestAmount-' + cardData.id"
            >
              <ng-container
                *ngIf="
                  showGoodBadInterests &&
                    cardData?.bankProduct?.product?.productDetails
                      ?.interestDetails?.effectiveInterestGood &&
                    cardData?.bankProduct?.product?.productDetails
                      ?.interestDetails?.effectiveInterestBad;
                  else showInterest
                "
              >
                {{
                  (
                    cardData?.bankProduct?.product?.productDetails
                      ?.interestDetails?.effectiveInterestGood * 100
                  )?.toLocaleString("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}% -
                {{
                  (
                    cardData?.bankProduct?.product?.productDetails
                      ?.interestDetails?.effectiveInterestBad * 100
                  )?.toLocaleString("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}%
              </ng-container>
              <ng-template #showInterest>
                {{
                  cardData.offerResponse.terms?.effectiveInterest.toLocaleString(
                    "de-DE",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )
                }}%
              </ng-template>
            </span>
            <span
              *ngIf="
                cardData.contractStateFlow !== 'PRELIMINARY' ||
                (cardData.contractStateFlow === 'PRELIMINARY' &&
                  cardData.bankProduct.bankDetails.bankGateway !== 'SANTANDER')
              "
              class="percent__text"
              [attr.id]="'interestText-' + cardData.id"
              >eff. Zins</span
            >
            <span
              *ngIf="
                cardData.contractStateFlow === 'PRELIMINARY' &&
                cardData.bankProduct.bankDetails.bankGateway === 'SANTANDER'
              "
              class="percent__text"
              [attr.id]="'interestText-' + cardData.id"
              >Voraussichtl. eff. Zins</span
            >
          </div>
          <svg-icon
            *ngIf="cardData.offerResponse.terms?.effectiveInterest"
            src="/resultpage/assets/icons/Zins.svg"
            class="percent__amount-wrap-inner__icon"
            [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
            aria-hidden="true"
          ></svg-icon>
        </div>
      </div>
      <div class="details-amount__rsv">
        <p
          [ngStyle]="{ 'font-size.px': 10 }"
          *ngIf="offersType !== 'noOffersOfApplication'"
        >
          Kreditschutz
        </p>
        <div
          class="details-amount__rsv--wrapper"
          *ngIf="offersType !== 'noOffersOfApplication'"
        >
          <p>
            {{
              cardData?.offerResponse?.terms?.creditProtection1?.type | rsvPipe
            }}
          </p>
          <svg-icon
            *ngIf="offersType !== 'noOffersOfApplication'"
            src="/resultpage/assets/icons/shield.svg"
            class="details-amount__rsv--wrapper--icon"
            [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
            aria-hidden="true"
          ></svg-icon>
        </div>
      </div>
    </div>
    <div
      class="content__details-options"
      *ngIf="offersType !== 'noOffersOfApplication'"
    >
      <div class="details-options__condition" role="list" tabindex="0">
        <ng-container
          *ngFor="
            let bullets of cardData.computedProductBullets;
            let i = index;
            trackBy: trackByBullet
          "
        >
          <p
            role="listitem"
            [attr.id]="'bullet-' + cardData.id + '-' + i"
            [class]="bullets.flag"
          >
            <svg-icon
              [ngClass]="['checkMark', 'checkMark_' + bullets.flag]"
              src="/resultpage/assets/icons/CHECKMARK.svg"
              [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
              aria-hidden="true"
            />
            {{
              bullets.name === "Komplettschutz" ||
              bullets.name === "Basisschutz" ||
              bullets.name === "Standardschutz"
                ? " Kreditschutzversicherung:"
                : ""
            }}
            {{ bullets.name }}
          </p>
        </ng-container>
      </div>
      <div
        class="condition__icon"
        style="display: flex; gap: 10px"
        *ngIf="showInterestExplanation && interestCalculationText.length > 0"
        tabindex="0"
        [attr.aria-labelledby]="'interestCalc-' + cardData.id"
      >
        <svg-icon
          [ngClass]="['checkMark', 'checkMark_GRAY']"
          src="/resultpage/assets/icons/CHECKMARK.svg"
          [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          aria-hidden="true"
        />
        <span [attr.id]="'interestCalc-' + cardData.id">
          {{ interestCalculationText }}
          <app-hint
            [displayCss]="'inline'"
            [hintData]="[{ text: interestExplanationHintText }]"
            *ngIf="
              windowSize === 'desktop' &&
              cardData.bankProduct.bankDetails.bankName !== 'Anadi Bank'
            "
          ></app-hint>
        </span>
      </div>
    </div>

    <div
      class="dialogOpenLinkWrapper"
      *ngIf="offersType !== 'noOffersOfApplication' && pageType !== 'archive'"
    >
      <button
        #kreditdetailsBtn
        class="dialogOpenLink"
        (click)="openCreditDetails(cardData.id)"
        (keydown)="onDialogKeydown($event)"
        [attr.aria-expanded]="openDetails"
        [attr.aria-controls]="'credit-details-' + cardData.id"
        [attr.id]="'toggle-details-' + cardData.id"
        aria-label="Kreditdetails anzeigen oder ausblenden"
        type="button"
      >
        <p aria-hidden="true">Kreditdetails</p>
        <svg-icon
          src="/resultpage/assets/icons/Chevron_Arrow.svg"
          [ngClass]="{
            'dialogOpenLink__icon--open': openDetails,
            dialogOpenLink__icon: true,
          }"
          [svgStyle]="{ 'width.px': 12, 'height.px': 12, 'margin.px': 1 }"
          aria-hidden="true"
        ></svg-icon>
      </button>
      <button
        *ngIf="hasCustomerRatings && customerRatingsData"
        #customerRatingsBtn
        class="dialogOpenLink"
        (click)="toggleCustomerRatings(cardData.id)"
        (keydown)="onCustomerRatingsKeydown($event)"
        [attr.aria-expanded]="openCustomerRatings"
        [attr.aria-controls]="'customer-ratings-' + cardData.id"
        [attr.id]="'toggle-customer-ratings-' + cardData.id"
        aria-label="Kundenbewertungen anzeigen oder ausblenden"
        type="button"
      >
        <div
          style="display: flex; gap: 4px; align-items: center"
          aria-hidden="true"
        >
          <app-star-rating
            [rating]="customerRatingsData.averageRate"
            size="medium"
            [filledColor]="'#333333'"
          ></app-star-rating>
          <span class="total-raters"
            >({{ customerRatingsData.totalRaters }})</span
          >
        </div>
        <svg-icon
          src="/resultpage/assets/icons/Chevron_Arrow.svg"
          [ngClass]="{
            'dialogOpenLink__icon--open': openCustomerRatings,
            dialogOpenLink__icon: true,
          }"
          [svgStyle]="{ 'width.px': 12, 'height.px': 12, 'margin.px': 1 }"
          aria-hidden="true"
        ></svg-icon>
      </button>
    </div>
    <div class="content__rate">
      <div
        class="rate__content"
        *ngIf="offersType !== 'noOffersOfApplication'"
        tabindex="0"
        [attr.aria-labelledby]="
          'rateContentAmount-' + cardData.id + ' rateContentText-' + cardData.id
        "
      >
        <svg
          *ngIf="!cardData.offerResponse.terms?.monthlyInstallment"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 39.81 30"
        >
          <defs>
            <style>
              .cls-1 {
                fill: #606060;
                font-family: MyriadPro-Regular, "Myriad Pro";
                font-size: 12px;
              }

              .cls-2 {
                fill: #666;
              }
            </style>
          </defs>
          <path
            class="cls-2"
            d="M20.46,18.27l-4.12-3V6.65c0-.51-.41-.92-.92-.92h-.84c-.51,0-.92,.41-.92,.92v9.52c0,.29,.14,.57,.38,.74l4.85,3.52h0c.41,.3,.98,.21,1.29-.2l.49-.67c.14-.2,.2-.44,.17-.68-.04-.24-.17-.46-.37-.6Z"
            vector-effect="non-scaling-stroke"
          />
          <path
            class="cls-2"
            d="M22.35,26.11c0-.31,.06-.62,.18-.91-2.18,1.61-4.82,2.48-7.53,2.48-7,0-12.69-5.69-12.69-12.68S8,2.32,15,2.32s12.69,5.69,12.69,12.68c0,.7-.06,1.4-.17,2.09,.75-.49,1.58-.85,2.45-1.07,.02-.34,.04-.68,.04-1.02,0-6.07-3.66-11.54-9.26-13.86C15.13-1.18,8.68,.1,4.39,4.39-1,9.79-1.49,18.37,3.26,24.33c4.75,5.97,13.22,7.43,19.69,3.39-.39-.45-.6-1.02-.6-1.61Z"
            vector-effect="non-scaling-stroke"
          />
          <text class="cls-1" transform="translate(20.84 24.92)">
            <tspan x="0" y="0">24h</tspan>
          </text>
        </svg>
        <p
          *ngIf="cardData.offerResponse.terms?.monthlyInstallment"
          class="content__amount"
          [attr.id]="'rateContentAmount-' + cardData.id"
        >
          <ng-container
            *ngIf="
              showGoodBadInterests &&
                goodMonthlyInstallment &&
                badMonthlyInstallment;
              else showInterest
            "
          >
            <ng-container
              >{{ currencyFormatter(goodMonthlyInstallment) }} -
              {{ currencyFormatter(badMonthlyInstallment) }}</ng-container
            >
          </ng-container>
          <ng-template #showInterest>
            {{
              currencyFormatter(
                cardData.offerResponse.terms?.monthlyInstallment
              )
            }}
          </ng-template>
        </p>
        <p class="content__text" [attr.id]="'rateContentText-' + cardData.id">
          <span *ngIf="cardData.contractStateFlow !== 'PRELIMINARY'"
            >monatliche Rate</span
          >
          <span *ngIf="cardData.contractStateFlow === 'PRELIMINARY'"
            >voraussichtliche mtl. Rate</span
          >
        </p>
        <p
          class="content__subtext"
          *ngIf="cardData.offerResponse.creditProtectionSelected"
        >
          inkl. Kreditschutz
        </p>
        <div class="promotion_badge" *ngIf="cardData.entitledForPromotion">
          Erste Monatsrate geschenkt!
        </div>
        <div class="content__incentives">
          <div
            class="incentives__payback"
            *ngIf="possiblePayback && cardData.paybackBasicPoints"
          >
            <img [src]="paybackImg" alt="payback point" />
          </div>
          <div class="incentives__cashback">
            <app-cashback
              *ngIf="
                cardData.bankProduct.product.productDetails.promotion &&
                cardData.bankProduct.product.productDetails.promotion.active
              "
              [cashbackData]="
                cardData.bankProduct.product.productDetails.promotion
              "
              [popup]="popup"
              [sliderWrapper]="sliderWrapper"
              [cardId]="cardData.id"
              (cashBackPopupChange)="
                popupToggle($event, cardData.id, 'cashback')
              "
            ></app-cashback>
          </div>
          <div
            *ngIf="
              cardData.smilyReward?.cashback || cardData.smilyReward?.points
            "
            class="incentives__smily"
          >
            <p
              *ngIf="
                cardData.smilyReward?.points && !cardData.smilyReward?.cashback
              "
              class="incentives__smily-badge"
            >
              <span class="incentives__smily-badge-value">{{
                cardData.smilyReward.points
              }}</span>
              <span class="incentives__smily-badge-brand">Smily</span
              ><span class="incentives__smily-badge-type">Punkte</span>
            </p>
            <p
              *ngIf="cardData.smilyReward?.cashback"
              class="incentives__smily-badge"
            >
              <span class="incentives__smily-badge-value"
                >{{ cardData.smilyReward.cashback | number: "1.0-0" }} €</span
              >
              <span class="incentives__smily-badge-brand">Smily</span
              ><span class="incentives__smily-badge-type">Cashback</span>
            </p>
          </div>
        </div>
      </div>
      <div
        class="rate__coupon-panel"
        *ngIf="
          +windowCouponAmount > 0 && offersType !== 'noOffersOfApplication'
        "
      >
        <app-coupon
          [windowCouponLabel]="windowCouponLabel"
          [windowCouponAmount]="windowCouponAmount"
          [popup]="popup"
          [sliderWrapper]="sliderWrapper"
          [cardId]="cardData.id"
          (couponPopupChange)="popupToggle($event, cardData.id, 'coupon')"
        ></app-coupon>
      </div>
      <button
        class="rate__button"
        (click)="
          onClosingTrack(
            cardData.closingTrackToken,
            cardData.offerResponse?.terms?.loanAmount
          )
        "
        *ngIf="
          pageType !== 'archive' &&
          (cardData.contractState === 'NEW' ||
            cardData.contractState === 'PRELIMINARY_OFFER' ||
            cardData.contractState === 'PRELIMINARY_ACCEPTED' ||
            cardData.contractState === 'ACCEPTED' ||
            cardData.contractState === 'IDENT_STARTED' ||
            cardData.contractState === 'IDENT_FINISHED' ||
            cardData.contractState === 'DOCUMENTS_MISSING' ||
            cardData.contractState === 'DOCUMENTS_MISSING_2ND' ||
            (cardData.contractState === 'CLOSING_FINISHED' &&
              cardData.bankProduct.bankDetails.bankGateway === 'NOVUMBANK'))
        "
      >
        <span
          *ngIf="
            (eternalPage &&
              cardData.contractStateFlow !== 'PRELIMINARY' &&
              (cardData.contractState === 'NEW' ||
                cardData.contractState === 'ACCEPTED')) ||
            (eternalPage &&
              cardData.contractStateFlow === 'CLICKOUT' &&
              cardData.contractState === 'PRELIMINARY_OFFER') ||
            ((cardData.contractStateFlow === 'PRELIMINARY' ||
              cardData.contractStateFlow === 'CLICKOUT') &&
              cardData.contractState === 'PRELIMINARY_ACCEPTED' &&
              cardData.bankProduct.bankDetails.bankGateway !== 'OBERBANK')
          "
          >zum Kreditabschluss</span
        >
        <span
          *ngIf="
            cardData.contractStateFlow === 'PRELIMINARY' &&
            cardData.contractState === 'PRELIMINARY_ACCEPTED' &&
            cardData.bankProduct.bankDetails.bankGateway == 'OBERBANK'
          "
          >zur Terminvereinbarung</span
        >
        <span *ngIf="cardData.contractState === 'IDENT_STARTED'"
          >zur Videotelefonie</span
        >
        <span
          *ngIf="
            (cardData.contractStateFlow === 'PRELIMINARY' &&
              cardData.contractState === 'PRELIMINARY_OFFER') ||
            (cardData.contractStateFlow !== 'PRELIMINARY' &&
              cardData.contractState === 'IDENT_FINISHED')
          "
          >zum Dokumentenupload</span
        >
        <span
          *ngIf="
            cardData.contractState === 'DOCUMENTS_MISSING' ||
            cardData.contractState === 'DOCUMENTS_MISSING_2ND'
          "
          >Unterlagen nachreichen</span
        >
        <span
          *ngIf="
            (!eternalPage &&
              cardData.contractStateFlow !== 'PRELIMINARY' &&
              cardData.contractStateFlow !== 'CLICKOUT' &&
              (cardData.contractState === 'NEW' ||
                cardData.contractState === 'ACCEPTED')) ||
            (!eternalPage &&
              cardData.contractStateFlow === 'CLICKOUT' &&
              cardData.contractState === 'PRELIMINARY_OFFER') ||
            (cardData.contractStateFlow === 'DEFAULT' &&
              cardData.contractState === 'PRELIMINARY_ACCEPTED') ||
            (cardData.contractState === 'CLOSING_FINISHED' &&
              cardData.bankProduct.bankDetails.bankGateway === 'NOVUMBANK')
          "
          >weiter</span
        >
      </button>
      <button
        class="rate__waitingButton"
        *ngIf="
          pageType !== 'archive' &&
          offersType === 'noOffersOfApplication' &&
          cardData.state === 'IN_PROGRESS'
        "
      >
        warten auf Bank <span class="loader"></span>
      </button>
      <p
        class="rate__text"
        *ngIf="
          pageType !== 'archive' &&
          (cardData.contractState === 'REJECTED' ||
            cardData.contractState === 'DOCUMENTS_UPLOADED' ||
            cardData.contractState === 'DOCUMENTS_UPLOADED_2ND' ||
            cardData.contractState === 'DOCUMENTS_CHECKED' ||
            cardData.contractState === 'DOCUMENTS_CHECKED_2ND' ||
            cardData.contractState === 'REJECTED_2ND' ||
            cardData.contractState === 'REJECTED_CLEARING' ||
            (cardData.contractState === 'CLOSING_FINISHED' &&
              cardData.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK') ||
            cardData.contractState === 'CLOSED')
        "
      >
        <b
          class="icon-warning"
          *ngIf="
            cardData.contractState === 'REJECTED' ||
            cardData.contractState === 'REJECTED_2ND' ||
            cardData.contractState === 'REJECTED_CLEARING'
          "
          >!</b
        >
        <svg
          *ngIf="
            cardData.contractState === 'DOCUMENTS_UPLOADED' ||
            (cardData.contractState === 'CLOSING_FINISHED' &&
              cardData.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK') ||
            (cardData.contractStateFlow === 'PRELIMINARY' &&
              cardData.contractState === 'IDENT_FINISHED')
          "
          class="icon-clock"
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 34 34"
          height="32"
          width="32"
        >
          <g transform="translate(1, 1)">
            <title>clock</title>
            <path
              d="M16.352 14.464v-6.048h-1.28v6.144c-0.32 0.256-0.672 0.736-0.672 1.28 0 0.832 0.704 1.472 1.536 1.472 0.608 0 1.12-0.256 1.376-0.896h5.44v-1.28h-5.504c-0.16-0.32-0.576-0.544-0.896-0.672z"
              fill="#444"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M31.744 19.36c0.224-1.088 0.32-2.272 0.32-3.456 0-0.512-0.032-1.024-0.064-1.536-0.832-8.064-7.648-14.368-15.968-15.968-8.864 0-16.032 7.168-16.032 16.032 0 7.424 5.024 13.664 11.872 15.488 1.312 0.32 2.656 0.48 4.096 0.48 1.984 0 3.84-0.32 5.536-0.864 5.152-1.888 9.088-6.304 10.24-11.776zM16.352 28.896v-3.2h-1.28v3.168c-6.72-0.416-11.744-5.728-12.032-12.448h2.752v-1.28h-2.72c0.448-6.4 5.6-11.68 12-12.096v2.816h1.28v-2.816c6.72 0.288 12.096 5.376 12.544 12.096h-3.264v1.28h3.264c-0.288 6.72-5.504 12.16-12.544 12.48z"
              fill="#444"
              vector-effect="non-scaling-stroke"
            />
          </g>
        </svg>
        <b
          class="icon-ok"
          *ngIf="
            cardData.contractState === 'DOCUMENTS_CHECKED' ||
            cardData.contractState === 'CLOSED'
          "
        ></b>
        <span
          *ngIf="
            cardData.contractState === 'REJECTED' ||
            cardData.contractState === 'REJECTED_2ND' ||
            cardData.contractState === 'REJECTED_CLEARING'
          "
          >abgelehnt</span
        >
        <span
          *ngIf="
            cardData.contractStateFlow === 'PRELIMINARY' &&
            cardData.contractState === 'IDENT_FINISHED'
          "
          >Vertrag wird an Bank übermittelt</span
        >
        <span
          *ngIf="
            cardData.contractState === 'DOCUMENTS_UPLOADED' ||
            cardData.contractState === 'DOCUMENTS_UPLOADED_2ND'
          "
          >Dokumente werden geprüft</span
        >
        <span
          *ngIf="
            cardData.contractState === 'DOCUMENTS_CHECKED' ||
            cardData.contractState === 'DOCUMENTS_CHECKED_2ND'
          "
          >Dokumente werden geprüft</span
        >
        <span
          *ngIf="
            cardData.contractState === 'CLOSING_FINISHED' &&
            cardData.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK'
          "
          >Kreditauszahlung wird geprüft</span
        >
        <span
          *ngIf="cardData.contractState === 'CLOSED' && pageType !== 'active'"
        >
          Kredit wird ausbezahlt
        </span>
      </p>
      <p
        class="rate__text"
        *ngIf="
          offersType === 'noOffersOfApplication' &&
          cardData.state !== 'IN_PROGRESS'
        "
      >
        <svg-icon
          class="icon-cross"
          src="/resultpage/assets/icons/crossRed.svg"
        />
        <b>kein Angebot der Bank</b>
      </p>
    </div>
    <div
      class="waitingButton-mobile"
      *ngIf="
        pageType !== 'archive' &&
        offersType === 'noOffersOfApplication' &&
        cardData.state === 'IN_PROGRESS'
      "
    >
      <p>warten auf Bank</p>
      <span class="loader"></span>
    </div>
  </div>
  <div
    class="offer_card-details"
    *ngIf="
      openDetails &&
      offersType !== 'noOffersOfApplication' &&
      pageType !== 'archive'
    "
    [attr.id]="'credit-details-' + cardData.id"
    role="region"
    [attr.aria-labelledby]="'toggle-details-' + cardData.id"
  >
    <div class="details__header">
      <div
        class="header__title--wrap"
        role="tablist"
        aria-label="Kreditdetails Kategorien"
      >
        <button
          #tabButton
          class="header__title"
          [class.active]="activated === 0"
          (click)="switchDetails(0, cardData.id)"
          (keydown)="onTabKeydown($event, 0, cardData.id)"
          role="tab"
          [attr.aria-selected]="activated === 0"
          [attr.tabindex]="activated === 0 ? 0 : -1"
          [attr.aria-controls]="'tabpanel-product-' + cardData.id"
        >
          Produkt
        </button>
        <div class="header__title-line"></div>
      </div>
      <div class="header__title--wrap">
        <button
          #tabButton
          class="header__title"
          [class.active]="activated === 1"
          (click)="switchDetails(1, cardData.id)"
          (keydown)="onTabKeydown($event, 1, cardData.id)"
          role="tab"
          [attr.aria-selected]="activated === 1"
          [attr.tabindex]="activated === 1 ? 0 : -1"
          [attr.aria-controls]="'tabpanel-conditions-' + cardData.id"
        >
          Konditionen
        </button>
        <div class="header__title-line"></div>
      </div>
      <div class="header__title--wrap">
        <button
          #tabButton
          class="header__title"
          [class.active]="activated === 2"
          (click)="switchDetails(2, cardData.id)"
          (keydown)="onTabKeydown($event, 2, cardData.id)"
          role="tab"
          [attr.aria-selected]="activated === 2"
          [attr.tabindex]="activated === 2 ? 0 : -1"
          [attr.aria-controls]="'tabpanel-proof-' + cardData.id"
        >
          Nachweise
        </button>
        <div class="header__title-line"></div>
      </div>
    </div>
    <div class="details__content">
      <div
        *ngIf="activated === 0"
        [attr.id]="'tabpanel-product-' + cardData.id"
        role="tabpanel"
        [attr.aria-labelledby]="'tab-product-' + cardData.id"
      >
        <app-product
          [productData]="cardData"
          [focusParentTab]="focusTabByIndex.bind(this, 0)"
        ></app-product>
      </div>
      <div
        *ngIf="activated === 1"
        [attr.id]="'tabpanel-conditions-' + cardData.id"
        role="tabpanel"
        [attr.aria-labelledby]="'tab-conditions-' + cardData.id"
      >
        <app-conditions
          [conditionsData]="cardData"
          [focusParentTab]="focusTabByIndex.bind(this, 1)"
        ></app-conditions>
      </div>
      <div
        *ngIf="activated === 2"
        [attr.id]="'tabpanel-proof-' + cardData.id"
        role="tabpanel"
        [attr.aria-labelledby]="'tab-proof-' + cardData.id"
      >
        <app-proof
          [proofData]="cardData"
          [focusParentTab]="focusTabByIndex.bind(this, 2)"
        ></app-proof>
      </div>
    </div>
  </div>
  <div
    class="customer-ratings-section"
    *ngIf="openCustomerRatings && offersType !== 'noOffersOfApplication'"
    [attr.id]="'customer-ratings-' + cardData.id"
    role="region"
    [attr.aria-labelledby]="'toggle-customer-ratings-' + cardData.id"
  >
    <div class="rating-count">
      <app-customer-ratings
        [productId]="cardData.bankProduct.product.productDetails.productId"
        [bankName]="cardData.bankProduct.bankDetails.bankName"
      ></app-customer-ratings>
    </div>
    <div class="comment-section">
      <app-customer-feedback
        [productId]="cardData.bankProduct.product.productDetails.productId"
      ></app-customer-feedback>
    </div>
  </div>
</div>
